import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Global Info Admin was removed. Keep a redirect so bookmarked
 * `/preferences/organization` URLs do not render a broken page.
 */
export const Route = createFileRoute('/_auth/preferences/organization')({
  beforeLoad: () => {
    throw redirect({
      to: '/404',
      replace: true,
    })
  },
})
